import { Component, OnInit, ViewChild } from '@angular/core';
import { RebateRequestComponent } from 'src/app/front-user/services/long-haul/rebate-request/rebate-request.component';
import { LongHaulRequestOptionFormulatedDecision, LongHaulRequestFormulateDecision, LongHaulRequestOption, LongHaulRequestMarkRefunded } from 'src/app/shared/models/long-haul.model';
import { LongHaulService } from 'src/app/shared/services/long-haul.service';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { Router } from '@angular/router';
import { User } from 'src/app/front-user/shared/models/user.model';
import { ErrorsEnum } from 'src/app/shared/models/enums.model';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';

@Component({
  selector: 'app-mark-request-refunded',
  templateUrl: './mark-request-refunded.component.html'
})

export class MarkRequestRefundedComponent implements OnInit {
  //#region Properties & Variables
  private rebateRequestId: string = "";
  @ViewChild('rebateRequest',{static: false}) rebateRequest: RebateRequestComponent;
  //Options
  private longHaulRequestFormulateDecisionRequest: LongHaulRequestFormulateDecision = new LongHaulRequestFormulateDecision();
  private longHaulRequestFormulateDecisionResponse: LongHaulRequestFormulateDecision = new LongHaulRequestFormulateDecision();
  private getRequestToFormulateDecisionResponseObject: ResponseObject = new ResponseObject();
  public longHaulRequestOptions: LongHaulRequestOption[] = [];
  //Submit
  private longHaulRequestMarkRefundedRequest: LongHaulRequestMarkRefunded = new LongHaulRequestMarkRefunded();
  public isRequestSucceeded: boolean = false;
  private noOfLoadedComponents: number = 0;
  private noOfComponentsToLoad: number = 2;
  private getMarkRequestRefundedResponseObject: ResponseObject = new ResponseObject();
  //Form Mode
  private formMode: FormMode = FormMode.New;
  private longHaulRequestGetMarkRefundedResponse: LongHaulRequestMarkRefunded = new LongHaulRequestMarkRefunded();
  //User Properties
  public currentUser: User = new User();
  public submitConfirmationMode: ConfirmationMode = ConfirmationMode.Success;
  //#endregion

  constructor(private longHaulService: LongHaulService, private globalServices: GlobalServices, private router: Router, private authenticationService: AuthenticationService) {
    //this.currentUser = this.globalServices.user;
    this.currentUser = this.authenticationService.currentUserValue;
  }

  ngOnInit() {}
  onRebateRequestLoadedFlag(flag: boolean) {
    if(flag){
      this.rebateRequestId = this.rebateRequest.rebateRequestLoaded.Id;
      this.rebateRequest.showOptionDev = false;
      this.rebateRequest.editModeAdmin = true;
      this.longHaulRequestOptions = this.rebateRequest.rebateRequestLoaded.LongHaulRequestOptions;
      this.setDefaults();
    }
  }
  setDefaults(): void {
    this.getRebateRequestOptions();
    this.getMarkRefundedRequest();
  }
  getRebateRequestOptions(): void {
    this.longHaulRequestFormulateDecisionRequest.LongHaulRequestId = this.rebateRequestId;
    for(let i: number = 0; i < this.longHaulRequestOptions.length; i++){
      this.longHaulRequestFormulateDecisionRequest.LongHaulRequestOptionsFormulatedDecision[i] = new LongHaulRequestOptionFormulatedDecision();
      this.longHaulRequestFormulateDecisionRequest.LongHaulRequestOptionsFormulatedDecision[i].Id = this.longHaulRequestOptions[i].Id;
    }
    this.getRebateRequestToFormulateDecision();
  }
  getRebateRequestToFormulateDecision(): void {
    this.longHaulRequestFormulateDecisionRequest.IsFormulatedDecisionComponent = true;
    this.longHaulService.getRebateRequestToFormulateDecision(this.longHaulRequestFormulateDecisionRequest).subscribe(
      data => this.getRequestToFormulateDecisionResponseObject = data,
      () => console.log("Something went wrong!!"),
      () => this.getRebateRequestToFormulateDecisionCompleted()
    );
  }
  getRebateRequestToFormulateDecisionCompleted(): void {
    if(this.getRequestToFormulateDecisionResponseObject.Success) {
      this.longHaulRequestFormulateDecisionResponse = this.getRequestToFormulateDecisionResponseObject.Data as LongHaulRequestFormulateDecision;
      this.checkLoadedComponents();
    } else {
      //Enable Error
      this.submitConfirmationMode = ConfirmationMode.Error;
      this.isRequestSucceeded = true;
      //Disable Loader
      this.globalServices.isLoaderEnabled = false;
    }
  }
  getMarkRefundedRequest(): void {
    this.longHaulService.getMarkRefunded(this.rebateRequestId).subscribe(
      data => this.getMarkRequestRefundedResponseObject = data,
      () => console.log("Something went wrong!!"),
      () => this.getMarkRefundedRequestCompleted()
    );
  }
  getMarkRefundedRequestCompleted(): void {
    if(this.getMarkRequestRefundedResponseObject.Success) {
      this.longHaulRequestGetMarkRefundedResponse = this.getMarkRequestRefundedResponseObject.Data as LongHaulRequestMarkRefunded;
      if(this.longHaulRequestGetMarkRefundedResponse != null){
        if(this.longHaulRequestGetMarkRefundedResponse.IsRefunded){
          this.longHaulRequestMarkRefundedRequest.IsRefunded = this.longHaulRequestGetMarkRefundedResponse.IsRefunded;
          this.longHaulRequestMarkRefundedRequest.IsClosed = this.longHaulRequestGetMarkRefundedResponse.IsClosed;
          this.formMode = FormMode.Details;
        }
      }
      this.checkLoadedComponents();
    } else {
      //Enable Error
      this.submitConfirmationMode = ConfirmationMode.Error;
      this.isRequestSucceeded = true;
      //Disable Loader
      this.globalServices.isLoaderEnabled = false;
    }
  }
  checkLoadedComponents(){
    this.noOfLoadedComponents++;
    if(this.noOfLoadedComponents == this.noOfComponentsToLoad){
      const el = document.getElementsByClassName('sectionTitle');
      el[0].scrollIntoView({behavior:'smooth'});
      //Disable Loader
      this.globalServices.isLoaderEnabled = false;
    }
  }
  submit(): void {
    this.longHaulRequestMarkRefundedRequest.Id = this.rebateRequestId;
    //Enable Loader
    this.globalServices.isLoaderEnabled = true;
    this.longHaulRequestMarkRefundedRequest.AdminEmail = this.currentUser.UserName != "" ? this.currentUser.UserName : this.currentUser.Email;
    this.markRequestRefunded();
  }
  markRequestRefunded(): void {
    this.longHaulService.markRefunded(this.longHaulRequestMarkRefundedRequest).subscribe(
      data => this.getRequestToFormulateDecisionResponseObject = data,
      () => console.log("Something went wrong!!"),
      () => this.markRequestRefundedCompleted()
    );
  }
  markRequestRefundedCompleted(): void {
    if(this.getRequestToFormulateDecisionResponseObject.Success) {
      this.longHaulRequestFormulateDecisionResponse = this.getRequestToFormulateDecisionResponseObject.Data as LongHaulRequestFormulateDecision;
    } else {
      //Enable Error / Warning
      if(this.getRequestToFormulateDecisionResponseObject.ErrorMessages[0] == ErrorsEnum.InternalServerError.toString())
        this.submitConfirmationMode = ConfirmationMode.Error;
      else if(this.getRequestToFormulateDecisionResponseObject.ErrorMessages[0] == ErrorsEnum.TaskCompletedByAnotherUser.toString())
        this.submitConfirmationMode = ConfirmationMode.Warning;
    }
    this.isRequestSucceeded = true;
    //Disable Loader
    this.globalServices.isLoaderEnabled = false;
  }
  later(): void {
    this.router.navigateByUrl('/workspace');
  }
}

enum FormMode {
  New = 1,
  Details = 2
}

enum ConfirmationMode {
  Success  = 1,
  Warning = 2,
  Error = 3
}
